import React from 'react'
import type { HTMLAttributes } from 'react'
import { csx } from '@vtex/admin-ui'

export type SearchImageProps = {
  src?: string
  alt: string
} & HTMLAttributes<HTMLDivElement>

export const SearchImage = ({ src, alt, css, ...props }: SearchImageProps) => (
  <div className={csx({ width: '100%', ...csx })} {...props}>
    <div
      className={csx({
        position: 'relative',
        paddingBottom: '100%',
      })}
    >
      {src && (
        <img
          src={src}
          alt={alt}
          className={csx({
            position: 'absolute',
            top: 0,
            left: 0,
            width: 'full',
            height: 'full',
            objectFit: 'contain',
            borderRadius: 'default',
          })}
        />
      )}
      <div
        className={csx({
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          background: 'rgba(0, 0, 0, 0.03)',
          borderRadius: 'default',
        })}
      />
    </div>
  </div>
)
